var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.25,
    stroke: "#E2B203",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2 12.888a.3.3 0 01.3-.3h1a.3.3 0 01.3.3v.812a.3.3 0 01-.3.3h-1a.3.3 0 01-.3-.3v-.812zM10.8 6.3a.3.3 0 00-.3-.3h-1a.3.3 0 00-.3.3v5.282a.3.3 0 00.3.3h1a.3.3 0 00.3-.3V6.3z",
    fill: "#E2B203"
  })));
}
export default SvgWarning;